import { render, staticRenderFns } from "./ability.vue?vue&type=template&id=6da1ab7e&scoped=true&"
import script from "./ability.vue?vue&type=script&lang=js&"
export * from "./ability.vue?vue&type=script&lang=js&"
import style0 from "./ability.vue?vue&type=style&index=0&id=6da1ab7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1ab7e",
  null
  
)

export default component.exports